import { colors, fontStyle } from "Constants";

export const emptyFieldContainerStyle = {
  border: `1px solid ${colors.borderDefault}`,
  borderRadius: "4px",
  backgroundColor: "transparent",
};

export const emptyFieldTitleStyle = { ...fontStyle.medium };
